
import { Union, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection } from "../../../Shared/Shared.js";
import { ConsumableStockRowValidation_$reflection } from "../../../Shared/Updater.js";
import { union_type, class_type, record_type, option_type, string_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(FormState, Rows, SelectedIdentifier, SelectedIdentifier2, Comment$) {
        super();
        this.FormState = FormState;
        this.Rows = Rows;
        this.SelectedIdentifier = SelectedIdentifier;
        this.SelectedIdentifier2 = SelectedIdentifier2;
        this.Comment = Comment$;
    }
}

export function State_$reflection() {
    return record_type("Importer.Updater.ConsumableStock.Types.State", [], State, () => [["FormState", FormState_$reflection()], ["Rows", list_type(ConsumableStockRowValidation_$reflection())], ["SelectedIdentifier", string_type], ["SelectedIdentifier2", option_type(string_type)], ["Comment", string_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateData", "DataImported", "SetIdentifier", "SetIdentifier2", "SetComment", "Validate", "ValidationCompleted", "DownloadTemplate", "DownloadedTemplate", "BlobReceived", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Importer.Updater.ConsumableStock.Types.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", string_type]], [["Item", option_type(string_type)]], [["Item", string_type]], [["Item", class_type("Browser.Types.FormData", undefined)]], [["Item", ClientApiResponse$1_$reflection(list_type(ConsumableStockRowValidation_$reflection()))]], [], [["Item1", class_type("Fetch.Types.Response")], ["Item2", string_type]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]], [["Item", class_type("System.Exception")]]]);
}

